'use client';
import Image from 'next/image';
import { Typography } from '@bgzt/ui';
import { LinkByEnvironment, Section, Spacing } from '~/components';
import { getShopInfo } from '~/utils/shop-service';
import { AUTHORIZED_SHOPS } from '~/constants';

import mandarakeLogoImage from '~/public/assets/images/mandarake_logo_image_4x.webp';
import ragTagLogoImage from '~/public/assets/images/ragtag_logo_image_4x.webp';
import mandarakeShopImage from '~/public/assets/images/mandarake_entry_card_image.webp';
import ragTagShopImage from '~/public/assets/images/ragtag_entry_card_image.webp';

import styles from './ShopEntryPoints.module.css';

type Props = {
  newBadge?: boolean;
};
export const ShopEntryPoints = ({ newBadge = false }: Props) => {
  const SHOP_LOGO_IMAGE = {
    [AUTHORIZED_SHOPS.mandarake.id]: mandarakeLogoImage,
    [AUTHORIZED_SHOPS.ragTag.id]: ragTagLogoImage,
  };
  const SHOP_IMAGE = {
    [AUTHORIZED_SHOPS.mandarake.id]: mandarakeShopImage,
    [AUTHORIZED_SHOPS.ragTag.id]: ragTagShopImage,
  };

  return (
    <Section>
      <div className={styles.shopEntryHeader}>
        <Typography variant={'L3'} color={'gray-900'}>
          일본 오프라인 샵을 그대로
        </Typography>
        {newBadge && <span className={styles.newBadge}>NEW</span>}
      </div>
      <Spacing height={16} />
      <ul className={styles.shopEntryList}>
        {Object.entries(AUTHORIZED_SHOPS).map(([key, shop]) => (
          <li className={styles.shopEntryItem} key={key}>
            <LinkByEnvironment href={`/shop/${shop.id}`} target="_blank">
              <div className={styles.shopEntryCard}>
                <div className={styles.shopEntryCardImage}>
                  <Image src={SHOP_IMAGE[shop.id]} alt={shop.id} width={162} height={80} unoptimized priority />
                </div>

                <div className={styles.shopEntryCardContent}>
                  <div className={styles.shopEntryCardLogo}>
                    <Image src={SHOP_LOGO_IMAGE[shop.id]} alt={shop.id} width={44} height={44} unoptimized priority />
                  </div>
                  <Typography variant={'L6'} color={'gray-900'}>
                    {getShopInfo(shop.id).shopNameKor}
                  </Typography>
                  <Typography variant={'L10'} color={'gray-500'}>
                    {getShopInfo(shop.id).shortDesc}
                  </Typography>
                </div>
              </div>
            </LinkByEnvironment>
          </li>
        ))}
      </ul>
    </Section>
  );
};
